<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div
              class="user-guide-top"
              :style="{
                height: (items.highlightArea.top + isMsgTop) + 'px'
              }"></div>
            <div
              class="user-guide-left"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                width: items.highlightArea.left + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-right"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                left: items.highlightArea.left + items.highlightArea.width + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: items.highlightArea.top + isMsgTop + items.highlightArea.height + 'px'
              }"></div>
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content" v-html="items.content"></div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/3</div>
            <div v-if="items.btnList.length" class="btnList flex">
              <div v-if="items.btnList.includes('next')" @click="nextStep(null)" class="gj-pointer completeBtn">下一步</div>
            </div>
          </div>
          <div v-if="items.guideDirection === 'left'" class="user-guide-point" :style="{ width: items.guideWidth + 'px', left: `-${items.guideWidth}px` }">
            <div class="user-guider-line"></div>
          </div>
          <div v-if="items.guideDirection === 'bottom'" class="user-guide-point-bottom" :style="{ height: items.guideWidth + 'px', bottom: `-${items.guideWidth}px`, left: '50%', marginLeft: `-4px` }">
            <div class="user-guider-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import {mapGetters} from "vuex";
const clientWidth = document.body.clientWidth;
const clientHeight = document.body.clientHeight;
export default {
  name: "new-user-guide",
  data() {
    return {
      bootSteps: 2,
      data: [],
      isMsgTop: 0,
      clientWidth
    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        this.isMsgTop = val ? 34 : 0;
      },
      immediate: true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    }
  },
  created() {
    this.initData()
    this.bootSteps = 2;
  },
  methods: {
    initData() {
      const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical';
      const subtractHeight =  isNavHorizontal ? 0 : 40;
      const addWidth =  isNavHorizontal ? 0 : 60;
      this.data = [
        {
          id: 2,
          class: "user-guide-one",
          type: 'default',
          needMask: true,
          highlightArea: {
            width: clientWidth - 60 - addWidth,
            height: clientHeight - 144 - 80 - 34 + subtractHeight,
            top: 144 - subtractHeight,
            left: 30 + addWidth,
          },
          guideArea: {
            top: 0,
            left: (clientWidth - 402 + addWidth)/2 ,
          },
          guideDirection: 'bottom',
          guideWidth: 30,
          content: "当插件获取到数据后，系统会解析数据到销售与财务模块，同时，也会在此留存一份亚马逊后台的原始报表您可以在此模块查看插件获取到的亚马逊原始报表",
          btnList: ['next'],
        }
      ]
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep() {
      this.$router.push({path:'/tool/cloud-plugin-status', query: {step: 3}})
    },
    temporarilyClosed() { // 暂时关闭，不退出引导状态
      this.bootSteps = 0;
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }
  }
  .user-guide-point-bottom {
    position: absolute;
    left: -40px;
    bottom: 0;
    .user-guider-line {
      height: 100%;
      width: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        bottom: -4px;
        left: -3px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
</style>